import { Component, inject } from '@angular/core';
import { GlobalLoaderService } from '../../services/global-loader.service';

import { DotLoaderComponent } from '@asiandevbank/intranet-ui';
@Component({
  selector: 'adb-global-loader',
  standalone: true,
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss'],
  imports: [DotLoaderComponent],
})
export class GlobalLoaderComponent {
  readonly loader = inject(GlobalLoaderService);
}
